/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description GuarantorRefundActions
 */
import { Dropdown } from 'antd';
import { MoreOne } from '@icon-park/react';
import { MenuItemType } from 'antd/es/menu/interface';

import Button from '.';
import { defaultDropdownButtonProps } from './ClaimTableActions';

export interface IProps {
	data: Guarantor.IGuarantorResponse;
}

const GuarantorRefundActions: React.FC<IProps> = ({ data }) => {
	const schema: MenuItemType[] = [
		{
			key: 'delete',
			className: 'tw-dropdown-menu-item',
			danger: true,
			label: <Button.DeleteGuarantorRefund data={data} {...defaultDropdownButtonProps} />,
		},
	];

	return (
		<Dropdown menu={{ items: schema }} trigger={['hover']} placement='bottomRight'>
			<Button icon={<MoreOne />} />
		</Dropdown>
	);
};

export default GuarantorRefundActions;
